module.exports = __webpack_public_path__ + "static/img/m_zhihui.fffa985.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/m_zhihui.png
// module id = bkU0
// module chunks = 1